export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12842.528f9d66.jpg";